import React, { Component } from 'react';
import logo from './logo.svg';
import * as d3 from 'd3';
import cx from 'classnames';
import './App.css';
import Container from './Graph/Context';
import Graph from './Graph';
import Force from './Graph/force';
import data from './fixtures/data.json';
import transactionData from './fixtures/transactions.json';
import transactionPathData from './fixtures/transactions_path.json';
import { Switch, Route } from 'react-router-dom';
import { uniq } from 'lodash';

const trimmedData = {
  nodes: transactionData.nodes,
  links: transactionData.links.filter((el, i) => i < 2000)
};

const linkIds = uniq(
  trimmedData.links.reduce((a, b) => [...a, b.source, b.target], [])
);

trimmedData.nodes = trimmedData.nodes.filter((el) => {
  return linkIds.indexOf(el.id) !== -1;
});

class App extends Component {
  state = {
    simMode: true,
    anchors: [],
    active: {},
    bundleKey: 'amount'
  };
  componentDidMount() {}
  handleAnchors = (anchors) => {
    this.setState({ anchors });
  };

  handleHover = (active = {}, incoming = false, depth = -1) => {
    this.setState({ active: { ...active, incoming, depth } });
  };

  money = d3.format('$,');

  getMoney = (leaf, data, depth) => {
    if (depth === 2) {
      return leaf.amount;
    }
    let total = 0;
    const { children } = leaf;
    children &&
      children.length &&
      children.forEach((child) => {
        total += child.amount;
      });
    return total;
  };

  render() {
    const { anchors, active } = this.state;
    return (
      <Switch>
        <Route exact path='/global'>
          <div>
            <div id='force-container'>
              <Container data={trimmedData} id='force-container'>
                <Force enabled />
              </Container>
            </div>
          </div>
        </Route>
        <Route exact path='/network'>
          <div
            id='force-container-path'
            style={{ opacity: this.state.simMode ? 1 : 0 }}
          >
            <Container data={transactionPathData} id='force-container-path'>
              <Force
                path
                pathData={data}
                handleAnchors={this.handleAnchors}
                enabled={this.state.simMode}
              />
            </Container>
          </div>
        </Route>
        <Route exact path='/radial' />
        <Route exact path='/'>
          <div>
            <div className='dashboard'>
              <div className='dashboard-row'>
                <div>View:</div>
                <button
                  className={cx({ active: this.state.simMode })}
                  onClick={() => {
                    this.handleHover({});
                    this.setState({ simMode: true });
                  }}
                >
                  Network
                </button>
                <button
                  className={cx({ active: !this.state.simMode })}
                  onClick={() => {
                    this.setState({ simMode: false });
                  }}
                >
                  Path
                </button>
              </div>
              <div
                className='dashboard-row'
                style={{
                  pointerEvents: this.state.simMode ? 'none' : 'all',
                  opacity: this.state.simMode ? 0 : 1
                }}
              >
                <div>Bundling:</div>
                <button
                  className={cx({ active: this.state.bundleKey === 'none' })}
                  onClick={() => {
                    this.handleHover({});
                    this.setState({ bundleKey: 'none' });
                  }}
                >
                  None
                </button>
                <button
                  className={cx({ active: this.state.bundleKey === 'state' })}
                  onClick={() => {
                    this.setState({ bundleKey: 'state' });
                  }}
                >
                  State
                </button>
                <button
                  className={cx({ active: this.state.bundleKey === 'amount' })}
                  onClick={() => {
                    this.handleHover({});
                    this.setState({ bundleKey: 'amount' });
                  }}
                >
                  Amount
                </button>
                <button
                  className={cx({
                    active: this.state.bundleKey === 'committee_party'
                  })}
                  onClick={() => {
                    this.setState({ bundleKey: 'committee_party' });
                  }}
                >
                  Party
                </button>
              </div>
              {active.leaf &&
                (active.incoming ? (
                  <div
                    className='dashboard-row'
                    style={{ pointerEvents: 'none' }}
                  >
                    {active.leaf.committee_name} gave{' '}
                    {this.money(
                      this.getMoney(active.leaf, active.data, active.depth)
                    )}{' '}
                    to {active.data.committee_name}
                  </div>
                ) : (
                  <div
                    className='dashboard-row'
                    style={{ pointerEvents: 'none' }}
                  >
                    {active.data.committee_name} gave{' '}
                    {this.money(
                      this.getMoney(active.leaf, active.data, active.depth)
                    )}{' '}
                    to {active.leaf.committee_name}
                  </div>
                ))}
            </div>
            <div
              id='force-container-path'
              style={{ opacity: this.state.simMode ? 1 : 0 }}
            >
              <Container data={transactionPathData} id='force-container-path'>
                <Force
                  path
                  pathData={data}
                  handleAnchors={this.handleAnchors}
                  enabled={this.state.simMode}
                />
              </Container>
            </div>
            {
              <div
                id='graph-container'
                style={{ pointerEvents: !this.state.simMode ? 'all' : 'none' }}
              >
                <Container data={data} id='graph-container'>
                  <Graph
                    bundleKey={this.state.bundleKey}
                    anchors={anchors}
                    enabled={!this.state.simMode}
                    handleHover={this.handleHover}
                  />
                </Container>
              </div>
            }
          </div>
        </Route>
      </Switch>
    );
  }
}

export default App;
